<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-img class="white--text" height="400px" src="/images/colette-and-gerard-mum.jpg">
          <v-container fill-height fluid>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <!-- <span class="headline">Welcome to the Coletti-Spaghetti Birthday Quiz</span> -->
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
        <v-card-title>
          <div>
            <!-- <span class="grey--text">Welcome to the Coletti-Spaghetti Birthday Quiz</span> -->
            <br>
            <!-- <span>Are you ready?</span><br> -->
            <span>You scored {{ getScore }}</span>
                    <h2 v-if="getScore < 4">Try harder to get your birthday special message.</h2>
        <h2
          v-else
        >Congratulations Spaghetti. Hope you enjoy your birthday as much as this quiz. Lots of love Gerard and Michelle.</h2>

          </div>
        </v-card-title>
        <v-card-actions>
          

        <v-btn v-if="getScore < 4" to="/">
          Start Again
        </v-btn>
        <v-btn v-else to="/special">
          Click here for your special prize
        </v-btn>


        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
export default {
  methods: mapMutations(['startAgain']),
  computed: mapGetters(['getScore']),
};
</script>



